export default __webpack_public_path__ + "static/media/imagePickAndPackContentSeven.ef027139.png";